import component from './contentAnalysis.vue'

export default component
